export const storeSearchLocally = (searchText, commonSearchesLength = 3) => {
  if (typeof window === "undefined") {
    return
  }

  //Get any locally stored searches and turn them into an array
  const localSearches = JSON.parse(localStorage.getItem("searches")) || []

  //Convert the search array into a set so that we prevent duplicates ...
  //... if we don't use a set we could end up with something like:
  //"Your Recent Searches"
  //"search"
  //"search"
  //"search"
  //We are also operating in reverse chronological order ...
  //... since sets always return the values in insertion order
  const searchSet = new Set(localSearches.reverse())

  //If the set already contains the incoming search text, remove it from the set ...
  //... this will maintain chronological order when we re-add it to the set ...
  //... since sets iterate in insertion order
  //... this process also prevents duplicates
  searchSet.has(searchText) && searchSet.delete(searchText)

  //Add the item to the set
  searchSet.add(searchText)

  //Create a new array with the new search text
  //Trim the array to match the total number of common searches (min 3 per design) ...
  //... taking the last x items (most recent)
  //Reverse the array so that the most recent is first
  const trimLength = commonSearchesLength < 3 ? 3 : commonSearchesLength
  const newSearches = [...searchSet].slice(-trimLength).reverse()

  // Remove short substrings from the newSearches array
  const filteredSearches = []

  for (let i = 0; i < newSearches.length; i++) {
    const current = newSearches[i]

    if (current.length > 4) {
      filteredSearches.push(current)
    } else {
      let useVal = true

      for (let j = 0; j < newSearches.length; j++) {
        const compared = newSearches[j]

        if (compared.includes(current)) {
          useVal = false
        }
      }

      if (useVal) {
        filteredSearches.push(current)
      }
    }
  }

  // Update the local storage to exclude substrings
  localStorage.setItem("searches", JSON.stringify(filteredSearches))

  //Store the new array in local storage
  localStorage.setItem("searches", JSON.stringify(filteredSearches))
}
